import { render, staticRenderFns } from "./ModalCategoryBanner.vue?vue&type=template&id=66920cfa&scoped=true&"
import script from "./ModalCategoryBanner.vue?vue&type=script&lang=js&"
export * from "./ModalCategoryBanner.vue?vue&type=script&lang=js&"
import style0 from "./ModalCategoryBanner.vue?vue&type=style&index=0&id=66920cfa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66920cfa",
  null
  
)

export default component.exports